module.exports = __webpack_public_path__ + "media/images/logos/blackwells-64ec1704ff49f0ae9540cdf54ce5dde2.png";